window.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.trigger-button').forEach(button => {
        button.addEventListener('click', (e) => {
            e.preventDefault();

            const target = e.currentTarget;
            if (!target) return;

            const handle = target.dataset.triggerHandle;
            const wrapper = target.closest('.shopify-section');
            if (!wrapper || !handle) return;

            // Toggle active state on buttons
            wrapper.querySelectorAll('.trigger-button').forEach(btn => {
            btn.classList.toggle(
                'trigger-active',
                btn.dataset.triggerHandle === handle
            );
            });

            // Toggle visibility on blocks
            wrapper.querySelectorAll('[data-block-trigger-handle]').forEach(block => {
            block.classList.toggle(
                'hidden',
                block.dataset.blockTriggerHandle !== handle
            );
            });
        });
    });
});